$(function() {
    $('#accept').click(function() {
        if ($(this).prop('checked')) {
            $('#next_but').prop('disabled', false);
        } else {
            $('#next_but').prop('disabled', true);
        }
    });

    $('#next_but').click(function() {
        if (!$('#accept').prop('checked')) {
            alert('アンケート使用目的に同意をお願いいたします。');
            return false;
        }
    });

});
